__turbopack_context__.v({
  "className": "karla_b7351e24-module__rW2oPG__className",
  "variable": "karla_b7351e24-module__rW2oPG__variable",
});
